export interface IChangeLog {
    id: number,
    labId: number,
    type: string,
    oldValue: string,
    newValue: string,
    dateChanged: string,
    changedBy: string
}

export interface ItempDto {
    id:number
}
